import { defaultProxyApiUrl } from './utils/proxyWs';

// Single source of truth for the API base URL.
// REACT_APP_BACKEND_URL is inlined by CRA at BUILD time (static string replacement).
//   - Production (Cloudflare Pages): the Pages build env sets it to the absolute backend
//     host (https://api.adlensfx.com), so the bundle calls that host directly.
//   - Local dev: unset → falls back to "" → relative /api/* paths, which the CRA dev
//     proxy (src/setupProxy.js) forwards to BACKEND_URL (default http://localhost:5050).
// NOTE: this only governs callers that go through API_BASE. Some callers fetch
// origin-relative /api/* directly (e.g. pages/MainApp.js, api/har.js) and
// therefore ALWAYS resolve against the page origin — in prod those
// still hit the CF Pages Function at functions/api/[[path]].js, which proxies to the
// backend. So that Function is live in production, not just a preview fallback.

const API_BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

// Proxy REST API base: env value, else http://localhost:8001 when served from localhost
// (never prod), else '' (callers keep their own relative fallback).
const PROXY_API_BASE = defaultProxyApiUrl(
  process.env.REACT_APP_PROXY_API_URL,
  typeof window !== 'undefined' ? window.location.hostname : ''
);

export { API_BASE, PROXY_API_BASE };
export default API_BASE;
